import { Observable } from 'rxjs/Rx'
import { Course } from '../../models/course'
import { HttpHelper } from '../../../helpers'

// MP-TODO: (enhancement): Temporary Service |
// This service is temporary until we create a proper course API
export class CourseService {
  private _endpoint: string = '//apis.manhattanprep.com/legacy/:testLine/classes/:action?:params'
  private _testLines = ['gmat', 'gre', 'lsat']

  public constructor(
    private _httpHelper: HttpHelper
  ) {}

  public findUserUpgrades(userId: string): Observable<Course[]> {
    const upgradeObservables = this._testLines.map((testLine) => {
      const endpoint = this._getEndpoint(testLine, 'userupgrades/', `mprep_user_id=${userId}`)
      return this._httpHelper.get(endpoint)
    })
    return Observable.forkJoin(upgradeObservables)
      .map((coursesJson: string[]) => {
        return coursesJson
          .reduce((result, current) => result.concat(current), [])
          .map((json) => this._createCourse(json))
      })
  }

  private _getEndpoint(testLine: string, action: string, params: string) {
    return this._endpoint.replace(':testLine', testLine)
      .replace(':action', action)
      .replace(':params', params)
  }

  private _createCourse(json): Course {
    const course = new Course()
    course.id = json.EventID
    course.name = json.EventName
    course.instructor = json.instructor
    course.coInstructor = json.coInstructor
    course.deactivateOn = new Date(json.DateDeactive)
    course.startDate = new Date(json.startDate)
    course.endDate = new Date(json.endDate)
    course.price = json.EventPrice
    course.location = json.location
    course.testLine = json.testLine
    course.schedule = json.schedule
    course.active = !!json.Active
    return course
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/services/course/course.service.ts